import { useWorkflowStore } from '../stores/workflowStore'

import { registerSessionReset } from '@/features/auth'

/** Clear workspace-scoped definitions on logout so no workflow data crosses tenant sessions. */
export function registerWorkflowSessionReset(): () => void {
  const store = useWorkflowStore()
  return registerSessionReset(() => store.reset())
}
